import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_SOCIAL_NETWORKS__REQUEST,
  ACTION_LOAD_SOCIAL_NETWORKS__SUCCESS,
  ACTION_LOAD_SOCIAL_NETWORKS__FAIL,
} from '../actionTypes';


const actionLoadSocialNetworksSuccess = data => ({
  type: ACTION_LOAD_SOCIAL_NETWORKS__SUCCESS,
  payload: { data },
});

const actionLoadSocialNetworksFail = error => ({
  type: ACTION_LOAD_SOCIAL_NETWORKS__FAIL,
  payload: { error },
});

export const actionLoadSocialNetworksRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_SOCIAL_NETWORKS__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/social_network'
    ).then(
      result => {
        dispatch(actionLoadSocialNetworksSuccess(result));
      },
      error => {
        dispatch(actionLoadSocialNetworksFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
